// import Swiper JS
import Swiper, { Autoplay, EffectFade, Navigation, Controller, Pagination } from 'swiper';
// import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';

window.addEventListener('DOMContentLoaded', () => {
    const homepageSlider = new Swiper('.homepage-slider', {
        modules: [Autoplay, EffectFade],
        effect: 'fade',
        speed: 800,
        centeredSlides: true,
        loop: true,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
    });

    const aboutCollaborations = new Swiper('.collaborations', {
        modules: [Navigation],
        slidesPerView: 2,
        spaceBetween: 20,
        loop: true,
        loopAdditionalSlides: 100,
        navigation: {
            prevEl: '.collaborations-button-prev',
            nextEl: '.collaborations-button-next',
        },
        breakpoints: {
            768: {
                slidesPerView: 3,
                spaceBetween: 25,
            },
            1440: {
                //slidesPerView cant be more than actual dom elements to work properly
                slidesPerView: 6,
                spaceBetween: 34,
            },
        },
    });

    const homeNews = new Swiper('.home-news', {
        modules: [Pagination],
        slidesPerView: 1,
        spaceBetween: 25,
        loop: true,
        pagination: {
            el: '.home-news-pagination',
            type: 'bullets',
            clickable: true,
        },
        breakpoints: {
            767: {
                slidesPerView: 2,
                spaceBetween: 25,
                loop: true,
            },
            1439: {
                slidesPerView: 3,
                spaceBetween: 91,
                loop: false,
            },
        },
    });

    // const homeTestimonials = new Swiper('.homepage-testimonials-slider', {
    //     modules: [Navigation,Pagination],
    //     slidesPerView: 1,
    //     spaceBetween: 25,
    //     loop: true,
    //     navigation: {
    //         nextEl: ".title-helper .next",
    //         prevEl: ".title-helper .prev",
    //     },
    //     pagination: {
    //         el: '.home-testimonials-pagination',
    //         type: 'bullets',
    //         clickable: true,
    //     },
    // });

    const pricePlans = new Swiper('.pricing-plan.mobile-view', {
        modules: [Pagination, Navigation],
        slidesPerView: 1,
        spaceBetween: 20,
        // loop: true,
        navigation: {
            prevEl: '.pricing-plan-button-prev',
            nextEl: '.pricing-plan-button-next',
        },
        pagination: {
            el: '.price-plans-pagination',
            type: 'bullets',
            clickable: true,
        },
        breakpoints: {
            768: {
                loop: false,
                noSwiping: true,
                noSwipingClass: 'swiper-slide',
            },
        },

    });

    pricePlans.on('slideChange', function(){
        closeAllForms()
    })
    pricePlans.on('slideChangeTransitionEnd', function(){
        properCheckbox()
    })

    const relatedPosts = new Swiper('.related-posts-wrapper', {
        modules: [Pagination],
        slidesPerView: 1,
        spaceBetween: 25,
        pagination: {
            el: '.related-posts-pagination',
            type: 'bullets',
            clickable: true,
        },
        breakpoints: {
            660: {
                slidesPerView: 1,
                spaceBetween: 25,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 25,
            },
            1440: {
                slidesPerView: 3,
                spaceBetween: 50,
            },
            1640: {
                slidesPerView: 3,
                spaceBetween: 90,
            },
        },
    });
});

function closeAllForms (){
    $('.pricing-plan-wrapper-mob').each(function(){
        $(this).hide()
        $(this).removeClass('open')
        $('.mobile-subtitle-trigger').removeClass('open')
    })
}

function properCheckbox () {
    $('.mobile-view .swiper-slide').each(function(){
        if( $(this).hasClass('swiper-slide-active') ){
            let pack = $(this).data('pack')
            $('.form-trigger-'+pack).click()
        }
    })
}
